// constants
import Papa from 'papaparse';
import { DOMAIN_NAMES_BY_ENV, DEV_DOMAIN_NAMES, ENV_LABELS_BY_ENV } from '../constants/general';

// utils
import { getEnv } from '../utils/env';

/*eslint-disable*/
export const groupBy = (arr, key) => (
    arr.reduce((result, item) => {
        const groupKey = item[key];
        result[groupKey] = result[groupKey] || [];
        result[groupKey].push(item);
        return result;
    }, {})
)

export const removeEmptyProperties = (obj) => {
    const newObj = Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => value !== '' && value !== null && value !== undefined && value?.length != 0)
    );
    return newObj;
  }


export const accessNestedProperty = (obj, path) => {
    const keys = path.split('.');
    const result = keys.reduce((acc, key) => {
      if (acc && acc.hasOwnProperty(key)) {
        return acc[key];
      } else {
        return undefined;
      }
    }, obj);
  
    return result;
  }

export const getDomainNames = () => {
  const env = getEnv();
  const domainNames  = DOMAIN_NAMES_BY_ENV[env] || DEV_DOMAIN_NAMES;
  return domainNames;
  }

  export const getEnvLabel = () => {
    const env = getEnv();
    const envLabel = ENV_LABELS_BY_ENV[env] || '';
    return envLabel;
  }


export const csvToJson = (csvFile) => {
  return new Promise(resolve => {
    Papa.parse(csvFile, {
      header: true,
      complete: function(results) {
        const users = results.data
        if (users.length>0 && Object.values(users[users.length-1]).every(x => x === null || x === undefined || x === '')) {
          users.splice(-1) // to account for Windows OS adding empty line to end of json
        }
        resolve({ users })
      },
      error: function(error) {
        throw new Error(error)
      },
    })
  }) 
}